import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card shadow-sm mb-4" }
const _hoisted_2 = { class: "card-content p-4" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "row visit-card" }
const _hoisted_7 = { class: "col-10" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "fw-bold text-secondary" }
const _hoisted_10 = { class: "overflow-hidden" }
const _hoisted_11 = {
  key: 1,
  class: "text-center pt-3"
}
const _hoisted_12 = {
  key: 1,
  class: "loading-card-area"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "card-header text-white bg-secondary fw-bold" }, "Featured Scenarios", -1)),
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.visit_loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (Object.keys(_ctx.props.featured_scenarios).length)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.props.featured_scenarios, (scenario) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: scenario.id,
                      class: "col-12",
                      onClick: ($event: any) => (_ctx.router.push({name:'scenario.overview',params:{id:scenario.id}}))
                    }, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("img", {
                            src: scenario.patient_image.location,
                            class: "rounded-circle float-start me-2",
                            width: "75"
                          }, null, 8, _hoisted_8),
                          _createElementVNode("div", _hoisted_9, _toDisplayString(scenario.patient_name), 1),
                          _createElementVNode("div", _hoisted_10, _toDisplayString(scenario.title), 1)
                        ]),
                        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "col-2 d-flex flex-column justify-content-center" }, [
                          _createElementVNode("h3", { class: "text-center" }, [
                            _createElementVNode("i", { class: "fas fa-arrow-circle-right text-primary" })
                          ])
                        ], -1))
                      ]),
                      _cache[1] || (_cache[1] = _createElementVNode("hr", { class: "w-75" }, null, -1))
                    ], 8, _hoisted_5))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("p", _hoisted_11, "No Featured Scenarios"))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createVNode(_component_loading, {
              active: _ctx.visit_loading,
              "is-full-page": false
            }, null, 8, ["active"])
          ]))
    ])
  ]))
}